module.exports = __webpack_public_path__ + "img/index-banner1.5434b62d.jpg";